import React from "react";
import "./Loading.css";

const Loading = ({
  size = "md",
  text = "Loading...",
  overlay = false,
  className = "",
  variant = "spinner",
}) => {
  const sizeClasses = {
    sm: "loading-sm",
    md: "loading-md",
    lg: "loading-lg",
  };

  const variants = {
    spinner: "spinner-border",
    dots: "loading-dots",
    pulse: "loading-pulse",
  };

  const LoadingContent = () => (
    <div className={`loading-container ${sizeClasses[size]} ${className}`}>
      {variant === "spinner" && (
        <div className={`${variants[variant]} text-primary`} role="status">
          <span className="visually-hidden">{text}</span>
        </div>
      )}

      {variant === "dots" && (
        <div className="loading-dots">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      )}

      {variant === "pulse" && (
        <div className="loading-pulse">
          <div className="pulse-circle"></div>
        </div>
      )}

      {text && variant !== "spinner" && (
        <div className="loading-text mt-2">{text}</div>
      )}
    </div>
  );

  if (overlay) {
    return (
      <div className="loading-overlay">
        <LoadingContent />
      </div>
    );
  }

  return (
    <div className="page-wrapper d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <div className="content container-fluid d-flex align-items-center justify-content-center">
        <LoadingContent />
      </div>
    </div>
  );
};

export default Loading;
